import { ITranslate } from "@/interfaces/ITranslate";

export const projectHasDietTypeTranslate: ITranslate = {
  cost: "el coste",
};
